import {PropsWithChildren} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {DocumentGenerationPaused} from './DocumentGenerationPaused';

type Props = {
  documentType: 'tenancy-agreement' | 'section-21' | 'both';
};

export const DocumentGenerationGuard = ({
  documentType,
  children,
}: PropsWithChildren<Props>) => {
  const {id} = useParams<{id: string}>();
  const [searchParams] = useSearchParams();

  const isNewCreation = id === 'new';
  const isRenewal =
    documentType === 'tenancy-agreement' && searchParams.has('renew-from');

  if (isNewCreation || isRenewal) {
    return <DocumentGenerationPaused documentType={documentType} />;
  }

  return <>{children}</>;
};
